import React, { Component } from 'react';

class ScreenCareEnd extends Component {
	render() {
		return (
			<section className="assessment screencare__end">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5">
							<h1>Your search for the right skincare ends here!</h1>
							<p>We feel the pain of trail and error in skincare, so we created Yours - we personalise your skincare routine so you don’t have to guess what’s right you.</p>
							<button type="button" class="btn btn-primary theme_btn">TRY NOW- $15</button>
						</div>
					</div>
					<img className="screencare__end--img" src="images/assessment/andria.png" />
				</div>
			</section>
		);
	}
}


export default ScreenCareEnd;